/**
 * Copyright by:
 *
 * by ESS-Ehrhardt Software Solutions & Service GmbH
 * Basselscheider Str. 55
 * D-56281 Emmelshausen
 * +49 (0) 67 42 / 87 27 0
 * info@epg.com
 */
import { Component, Input, Output, EventEmitter, TemplateRef } from '@angular/core';

export interface StandardListItemData {
  id: string;
  name: string;
  title?: string;
  subtitle?: string;
  routerLink?: string | any[];
  routerState?: any;
  [key: string]: any;
}

@Component({
  selector: 'app-standard-list-item',
  templateUrl: './standard-list-item.component.html',
  styleUrls: ['./standard-list-item.component.scss'],
  standalone: false
})
export class StandardListItemComponent {
  @Input() item!: StandardListItemData;
  @Input() isSelected: boolean = false;
  @Input() template?: TemplateRef<any>;

  @Output() itemClick = new EventEmitter<StandardListItemData>();

  onItemClick(): void {
    this.itemClick.emit(this.item);
  }
}
